module.exports = __webpack_public_path__ + "img/indikikijones.93696355.png";